import { Component, OnInit } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { BaReviewService } from 'src/app/Services/ba-review.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogModel, DialogComponent } from 'src/app/AppBaseComponents/dialog/dialog.component';

@Component({
  selector: 'ze-bareview',
  templateUrl: './bareview.component.html',
  styleUrls: ['./bareview.component.scss'],
  animations: [
    trigger('slideInOut', [
      state('closed', style({
        height: '0px',
        visibility: 'hidden',
        opacity: '0'
      })),
      state('open', style({
        height: '*',
        visibility: 'visible',
        opacity: '1'
      })),
      transition('closed <=> open', animate('300ms ease-in-out'))
    ])
  ]
})
export class BAReviewComponent implements OnInit {

  public selectedArtifactType: string = 'suite';
  artifactNames : any ;
  expandedArtifactId: string | null = null;
  artifactReviews: { [artifactId: string]: any[] } = {};
  sampleData : any;
  editableReviewId: string | null = null;
  editableReplyId: string | null = null;
  selectedReplyId: string | null = null;
  selectedReviewId: string | null = null;
  replyingToReviewId: string | null = null;
  newReplyComment: string = '';

  // ADDED for pagination
  
  currentPage: number = 0;
  pageSize: number = 5;
  hasNextPage: boolean = false;

  constructor(private baservice : BaReviewService , private dialog: MatDialog) { }


  ngOnInit() {
   this.onArtifactTypeChange();
  }

  onArtifactTypeChange() {
    if (this.selectedArtifactType) {
      this.getArtifactsHaveBaReviews();
      this.currentPage = 0;
    } else {
      this.artifactNames = []; // Clear the data if user resets selection
    }
  }

  onArtifactClick(artifactId: string) {
    if (this.expandedArtifactId === artifactId) {
      this.expandedArtifactId = null; // collapse
    } else {
      this.expandedArtifactId = artifactId;
      if (!this.artifactReviews[artifactId]) {
        this.getReviewCommentAndRepliesOnArtifact(artifactId);
      }
    }
  }

  public getArtifactsHaveBaReviews(){
    const artifactType = this.selectedArtifactType;
    let projectId = localStorage.getItem("projectId");
    this.baservice.bareviewPresentInProjectForArtifacts(artifactType, projectId , this.currentPage ).subscribe((data : any)=> {
      this.artifactNames = data.artifacts;
      this.hasNextPage = data.hasNextPage;
    })
  }

  nextPage() {
    if (this.hasNextPage) {
      this.currentPage++;
      this.getArtifactsHaveBaReviews();
    }
  }

  prevPage() {
    if (this.currentPage > 0) {
      this.currentPage--;
      this.getArtifactsHaveBaReviews();
    }
  }

  public getReviewCommentAndRepliesOnArtifact(artifactId: string) {
    this.baservice.reviewCommentAndRepliesOnArtifact(artifactId).subscribe(response => {
      if (response.operationStatus === 'SUCCESS') {
        this.artifactReviews[artifactId] = response.data.map(comment => ({
          _id: comment._id,
          review_comment: comment.review_comment,
          created_time: new Date(comment.created_time),
          created_by: comment.created_by,
          replies: comment.replies || [],
          resolved: comment.resolved,
          report_link: comment.report_link 
        }));
      }
    });
  }

  public editReview(reviewId: string) {
    const currentArtifactReviews = this.artifactReviews[this.expandedArtifactId!];
    const review = currentArtifactReviews && currentArtifactReviews.find(r => r._id === reviewId);
    if (review && !review.resolved) {
      this.editableReviewId = reviewId;
    } else {
      alert('Cannot edit an unresolved review');
    }
  }
  
  public cancelEdit() {
    this.editableReviewId = null;
  }

  editReply(replyId: string) {
    this.editableReplyId = replyId;
  }
  
  cancelReplyEdit() {
    this.editableReplyId = null;
  }

  toggleReplyOptions(replyId: string) {
    this.selectedReplyId = this.selectedReplyId === replyId ? null : replyId;
  }

  toggleReviewOptions(reviewId: string) {
    this.selectedReviewId = this.selectedReviewId === reviewId ? null : reviewId;
  }

  enableReplyInput(reviewId: string) {
   
    this.replyingToReviewId = reviewId;
    this.newReplyComment = '';
  }
  
  cancelReply() {
    this.replyingToReviewId = null;
    this.newReplyComment = '';
  }  
  
  deleteReview(artifactId: string, reviewId: string) {
  
    const currentArtifactReviews = this.artifactReviews[artifactId];
    const review = currentArtifactReviews && currentArtifactReviews.find(r => r._id === reviewId);
    if (!review || review.resolved) {
      alert('Cannot delete resolved review');
      return;
    }
    this.baservice.deleteReview(reviewId).subscribe((response) => {
      
      // Fetch updated review comments
      this.baservice.reviewCommentAndRepliesOnArtifact(artifactId).subscribe(updatedResponse => {
        if (updatedResponse.operationStatus === 'SUCCESS') {
          const updatedReviews = updatedResponse.data;

          // Update the local cache
          this.artifactReviews[artifactId] = updatedReviews;
  
          // If there are no more reviews, refresh the artifacts list
          if (!updatedReviews || updatedReviews.length === 0) {
            this.getArtifactsHaveBaReviews();
          }
        }
      });
  
    }, (error) => {
      console.log(error);
    });
  }

  deleteReply(artifactId: string, reviewId: string, replyId: string) {
    const currentArtifactReviews = this.artifactReviews[artifactId];
    const review = currentArtifactReviews && currentArtifactReviews.find(r => r._id === reviewId);
    if (!review || review.resolved) {
      alert('Cannot delete reply on resolved review');
      return;
    }

    this.baservice.deleteReply(reviewId, replyId).subscribe((response) => {
    
      this.getReviewCommentAndRepliesOnArtifact(artifactId);
    }, (error) => {
      console.log(error);
    });
  }

  //edit review
  public saveReview(reviewId: string, updatedReview: string) {
    const currentArtifactReviews = this.artifactReviews[this.expandedArtifactId!];
    const review = currentArtifactReviews && currentArtifactReviews.find(r => r._id === reviewId);
    if (!review || review.resolved) {
      alert('Cannot save resolved review');
      return;
    }
  
    this.baservice.editReview(reviewId, updatedReview).subscribe((response) => {
      this.editableReviewId = null;
      // Refresh the reviews for the current artifact
      this.getReviewCommentAndRepliesOnArtifact(this.expandedArtifactId!);
    });
  }
  
  //edit reply
  public saveReply(reviewId: string, replyId: string, updatedReply: string) {
    const currentArtifactReviews = this.artifactReviews[this.expandedArtifactId!];
    const review = currentArtifactReviews && currentArtifactReviews.find(r => r._id === reviewId);
    if (!review || review.resolved) {
      alert('Cannot save reply on unresolved review');
      return;
    }

    this.baservice.editReply(reviewId, replyId, updatedReply).subscribe((response) => {
      this.editableReplyId = null;
      this.getReviewCommentAndRepliesOnArtifact(this.expandedArtifactId!);
    });
  }

  //save reply
  public submitReply(artifactId: string, reviewId: string) {
    const currentArtifactReviews = this.artifactReviews[artifactId];
    const review = currentArtifactReviews && currentArtifactReviews.find(r => r._id === reviewId);
    if (!review || review.resolved) {
      alert('Cannot reply to an unresolved review');
      return;
    }
    if (!this.newReplyComment.trim()) return;

    const payload = {
      "reviewId": reviewId,
      "replyComment": this.newReplyComment
    };

    this.baservice.addReplyCommentToReview(payload).subscribe({
      next: (response) => {
        // Clear the reply input field
        this.cancelReply();
        // Refresh the reviews for this artifact
        this.getReviewCommentAndRepliesOnArtifact(artifactId);
      },
      error: (error) => {
        console.error('Error adding reply:', error);
      }
    });
  }

  public toggleReviewResolved(reviewId: string) {
    const currentArtifactReviews = this.artifactReviews[this.expandedArtifactId!];
    const review = currentArtifactReviews && currentArtifactReviews.find(r => r._id === reviewId);
   
    if (!review) return;
    if (review.resolved) {
      // If the review is resolved, no need to show the popup for unresolved
      this.resolveReview(reviewId, false); // Just resolve (unresolve without popup)
    }else{
        // Open the confirmation dialog
        const dialogData = new ConfirmDialogModel(
          'Resolve Review',
          'Do you want to send a mail for this resolution?'
        );
      
        const dialogRef = this.dialog.open(DialogComponent, {
          width: '800px',
          data: dialogData
        });
      
        dialogRef.afterClosed().subscribe((result) => {
          if (result === true) {
            this.resolveReview(reviewId, true);  // Send mail
          } else if (result === false) {
            this.resolveReview(reviewId, false); // Just resolve
          }
        });
      }
  }
  
  private resolveReview(reviewId: string, sendMail: boolean) {
    const currentArtifactReviews = this.artifactReviews[this.expandedArtifactId!];
    const review = currentArtifactReviews && currentArtifactReviews.find(r => r._id === reviewId);
    if (!review) return;
  
    review.resolved = !review.resolved;
    this.baservice.resolveReview(reviewId, sendMail).subscribe({
      next: (response) => {
        if (response.operationStatus !== 'SUCCESS') {
          review.resolved = !review.resolved;
        } else {
          console.log('Resolve status updated successfully');
        }
      },
      error: (error) => {
        review.resolved = !review.resolved;
        console.error('Error while resolving review:', error);
      }
    });
  }
  
  cancelReviewEdit() {
    this.editableReviewId = null;
  }
  onSubmit() {
   
  }
  isExpanded = false;
  artifactTypes = [
    { value: '', label: 'Artifact type', disabled: true },
    { value: 'suite', label: 'Suite', disabled: false },
    { value: 'feature', label: 'Feature', disabled: false },
    { value: 'scenario', label: 'Scenario', disabled: false }
  ];

  toggleExpand() {
    this.isExpanded = !this.isExpanded;
  }

}
